import ContasListPage from "./ContasListPage";

// Wrapper fino — toda a lógica está em ContasListPage({ tipo }).
export default function ContasReceberPage() {
  return <ContasListPage tipo="receber" />;
}
